import { render, staticRenderFns } from "./8.vue?vue&type=template&id=137560da&scoped=true&"
var script = {}
import style0 from "./8.vue?vue&type=style&index=0&id=137560da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137560da",
  null
  
)

export default component.exports